import React, { FC } from "react";
import { usePOSATypesSelector } from "../../../redux/actions/wheel";
import KC_Modal_2 from "../../../designsystem/KC_Modal/KC_Modal_2";
import NiceModal, { NiceModalHocProps, useModal } from "@ebay/nice-modal-react";
import KC_Heading3 from "../../../designsystem/typography/KC-Heading/KC_Heading3";
import { POSAMode } from "../../../app/19_JetpackConfig/components/POSAEditor/model";
import {
  POSA_FORMAT,
  POSATypeJavascriptDTO
} from "@tootsweet/model/lottery/POSAType";
import POSAEditorModal from "../../../app/19_JetpackConfig/components/POSAEditor/POSAEditorModal";
import PNGPreview from "../../SVGPreview/PNGPreview";
import KC_Card from "../../../designsystem/KC_Card/KC_Card";
import KC_Button, {
  KC_ButtonSize
} from "../../../designsystem/KC_Button/KC_Button";
import "./styles.scss";
import { tt } from "../../../utils/i18n/i18n";
import { useAccountToDisplaySelector } from "../../../redux/actions/user";
import { svgRenderer } from "../../../utils/svgRenderer";

interface Props {
  format: POSA_FORMAT;
  posaMode: POSAMode;
  posaList?: POSATypeJavascriptDTO[];
}

const POSASelectorModal: FC<Props & NiceModalHocProps> =
  NiceModal.create<Props>((props) => {
    const modal = useModal();
    const posaTypes = usePOSATypesSelector();
    const { accountToDisplay } = useAccountToDisplaySelector();

    const handleClose = () => {
      modal.resolve();
      void modal.hide();
    };

    const handleOpenEditModal = (
      posa: POSATypeJavascriptDTO,
      title: string,
      posaDestination: POSAMode
    ) => {
      void NiceModal.show(POSAEditorModal, {
        posa,
        title,
        posaDestination,
        enableDownload: false,
        svgID: svgRenderer.generateSVGId(posa._id)
      });
      handleClose();
    };

    return (
      <KC_Modal_2
        id="posa-selector-modal"
        isOpen={modal.visible}
        onClose={handleClose}
        className=""
        header={
          <div className="px-4 py-3">
            <KC_Heading3 text={tt("create_custom_design")} />
          </div>
        }
      >
        <div className="d-flex flex-column p-4">
          <div className="st-gap posa-selector-modal-grid">
            {props.posaList?.map((posa) => {
              return (
                <KC_Card
                  boxShadow={true}
                  className="align-items-center pt-4 px-5 posa-selector-modal-grid-item"
                >
                  <KC_Heading3
                    text={tt("posa_template", {
                      template: posa.shortId
                    })}
                  />
                  <PNGPreview
                    isBordered={true}
                    useTwicPics={true}
                    freeWidth={true}
                    posa={posa}
                  />
                  <KC_Button
                    id={`${posa._id}-btn`}
                    size={KC_ButtonSize.Large}
                    text={tt(posa.isCustom ? "personalize" : "select")}
                    isPrimary={true}
                    className="d-flex kc-btn-border-black-light "
                    onClick={() => {
                      handleOpenEditModal(
                        posa,
                        tt("edit_your_posa"),
                        props.posaMode
                      );
                    }}
                    extraStyle={{
                      width: "unset !important"
                    }}
                  />
                </KC_Card>
              );
            })}
          </div>
        </div>
      </KC_Modal_2>
    );
  });

export default POSASelectorModal;
